module.exports = __webpack_public_path__ + "img/badge-list-thumb-103.fdaf8ff2.png";